import { _ } from '@ngx-translate/core';
import { ICoordinateSystem } from '@app/api/interfaces/coordinate-system.interface';
import { ILocalizationKey } from '@app/core/interfaces/localization';
import { ITableColumn } from '@app/core/interfaces/table-column';

export const LD_COORDINATES_COLUMN_SORT_BY = 'customCoordinates.axis1';

export interface ILdCoordinatesText {
  key: ILocalizationKey;
  params?: Record<string, string>;
}

export function ldCoordinatesColumnHeaderTooltip(
  coordinateSystem: ICoordinateSystem | null | undefined
): Pick<ITableColumn, 'headerTooltip' | 'headerTooltipParams'> {
  return coordinateSystem
    ? {
        headerTooltip: _(`@@shared-tooltip-coordinates-system__text`),
        headerTooltipParams: { I18N_VAR_SYSTEM: coordinateSystem.name },
      }
    : { headerTooltip: _(`@@shared-tooltip-coordinates-wgs84__text`) };
}

export function ldCoordinatesFieldLabel(coordinateSystem: ICoordinateSystem | null | undefined): ILdCoordinatesText {
  return coordinateSystem
    ? {
        key: _(`@@shared-coordinates-with-system__text`),
        params: { I18N_VAR_SYSTEM: coordinateSystem.name },
      }
    : { key: _(`@@shared-coordinates__text`) };
}
